import { render, staticRenderFns } from "./ReSearchStaffClients.vue?vue&type=template&id=8f652d4e&scoped=true"
import script from "./ReSearchStaffClients.vue?vue&type=script&lang=js"
export * from "./ReSearchStaffClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f652d4e",
  null
  
)

export default component.exports